module.exports = __webpack_public_path__ + "static/jennifer-bde1b235ae76471e904636570dbd9220.jpg";